module.exports = __webpack_public_path__ + "img/aristote.55a6e257.jpg";